module.exports = __webpack_public_path__ + "img/tar.ae203093.png";